import React, { useState } from 'react'
import { Link } from 'react-router-dom'

const Pricing = () => {
  // const [amount,setAmount]=useState(0);
  const [rate, setRate] = useState(0)
  const [showError,setShowError]=useState(false)
  const [halfyearRate, sethalfyearRate] = useState(0)
  const [yearRate, setyearRate] = useState(0)
  // const default_rate = 1600000;

  const set_pricing = () => {
    if(rate>=100000){
      setShowError(false)
      var i = rate / 100000
    var price = 20 * i + 20 * (i - 1) * 0.1
    // setAmount(price)
    sethalfyearRate(Number((price * 6).toFixed(2)))
    setyearRate(Number((price * 11).toFixed(2)))
    }
    else{
      setShowError(true)
    }
  }

  const handleInputChange = (event) => {
    setRate(event.target.value)
  }

  return (
    <div className='text-center bg-white text-black px-12 py-24'>
      <div className='text-5xl md:text-6xl font-bold mb-10 mt-14'>Pricing Tiers</div>
      <div className='font-semibold text-2xl underline'>Free Trial Period For 10 Days </div>
      <div className='box-content p-4 mb-6 text-left'>
        <div className='p-4 flex flex-col justify-center border-solid border-gray-400 border-2 text-sm'>
          {/* <div className='text-3xl mb-4 text-left font-bold border-gray-400 border-b-2'>Enterprise</div> */}

          <div className='mb-2 text-2xl flex justify-center'>Enter your website's monthly pageviews</div>
          <div className='flex justify-center'>
            <input
              className='p-2 m-2 rounded border-2 border-solid border-gray-400 flex-shrink opacity-45 text-black w-32 md:flex-shrink'
              onChange={handleInputChange}
              placeholder='Enter Pageviews'
            />
              <button
                className='p-2 m-2 rounded bg-black opacity-45 text-white md:w-32 md:flex-shrink'
                onClick={set_pricing}
              >
                Get Pricing
              </button>
          </div>
          <span className='text-xs flex justify-center'>(100k minimum monthly pageviews required)</span>
          {showError &&
            <div className='text-red-600 flex justify-center'>Please enter value above 100K</div>}
          <div className='text-base mt-2 italic flex justify-center'>Starts At</div>
          <div className='md:text-4xl font-semibold flex text-3xl md:flex-wrap flex justify-center'>
            ${halfyearRate}{/* {((Enterprise_Rate-500000)/1000)*2} */}
            {/* <span className='line-through mr-4'>$349*</span>   */}
            {/* <span className='text-red text-base ml-2'>10% off</span> */}
          </div>
          <div className='text-base flex justify-center'>/6 months</div>
          <div className='text-lg mt-1 italic flex justify-center'>Or</div>
          <div className='mt-2 md:text-4xl font-semibold text-4xl flex justify-center'>${yearRate}</div>
          <div className='text-base mb-2 flex justify-center'>/year with one month free</div>
          <span className='text-xs flex justify-center'></span>
          {/* <div className='leading-none mb-2 text-3xl flex justify-center'>For 100K pageviews = $120 / 6 months.</div> */}

          <div className='justify-center m-auto mt-2 flex flex-wrap'>
            <Link to='/'>
              <button className='p-2 rounded bg-black opacity-45 text-white md:w-36 h-12 md:flex-shrink'>Get Started</button>
            </Link>
          </div>
          {/* <div className='text-sm mt-4 italic'>
            * plus 5% of all click through revenue.
          </div> */}
        </div>

        {/* <div className='p-4 flex flex-col justify-center border-solid border-gray-400 border-2 text-sm'>
          <div className='text-3xl mb-4 text-left font-bold border-gray-400 border-b-2'>Large</div>
          <div className='text-base leading-none mb-2'> 
          For Large Publishers with 100K-400K pageviews per month.
          </div>
          <div className='text-xs mt-2 italic'>Starts At</div>
          <div className='md:text-4xl text-3xl font-semibold flex md:flex-wrap'>
            $200*  
          </div>
          <div className='text-sm'>/month</div>
          <div className='text-base mt-1 italic'>Or</div>
          <div className='mt-2 text-4xl font-semibold'>$2199*</div>
          <div className='text-sm'>/year</div>
          <div className='justify-center m-auto mt-2 flex flex-wrap'>
            <Link to='/'>
            <button className='p-2 rounded bg-black opacity-45 text-white md:w-32 md:flex-shrink'>Get Started</button>
            </Link>
          </div>
          <div className='text-sm mt-4 italic'>
            * plus 5% of all click through revenue.
          </div>
        </div> */}

        {/* <div className='p-4 flex flex-col justify-center border-solid border-gray-400 border-2 text-sm'>
          <div className='text-3xl mb-4 text-left font-bold border-gray-400 border-b-2'>Medium</div>
          <div className='text-base leading-none mb-2'> 
          For Medium Publishers with 25K-100K pageviews per month.
          </div>
          <div className='text-xs mt-2 italic'>Starts At</div>
          <div className='md:text-4xl text-3xl font-semibold flex md:flex-wrap'>$50*</div>
          <div className='text-sm'>/month</div>
          <div className='text-base mt-1 italic'>Or</div>
          <div className='mt-2 text-4xl font-semibold'>$549*</div>
          <div className='text-sm'>/year</div>
          <div className='justify-center m-auto mt-2 flex flex-wrap'>
            <Link to='/'>
            <button className='p-2 rounded bg-black opacity-45 text-white md:w-32 md:flex-shrink'>Get Started</button>
            </Link>
          </div>
          <div className='text-sm mt-4 italic'>
            * plus 5% of all click through revenue.
          </div>
        </div> */}

        {/* <div className='p-4 flex flex-col justify-center border-solid border-gray-400 border-2 text-sm'>
          <div className='text-3xl mb-4 text-left font-bold border-gray-400 border-b-2'>Basic</div>
          <div className='text-base leading-none mb-2'> 
          For Small Publishers with upto 25K pageviews per month.
          </div>
          <div className='text-xs mt-2 italic'>Starts At</div>
          <div className='md:text-4xl text-3xl font-semibold flex md:flex-wrap'>$15*</div>
          <div className='text-sm'>/month</div>
          <div className='text-base mt-1 italic'>Or</div>
          <div className='mt-2 text-4xl font-semibold'>$165*</div>
          <div className='text-sm'>/year</div>
          <div className='justify-center m-auto mt-2 flex flex-wrap'>
            <Link to='/'>
            <button className='p-2 rounded bg-black opacity-45 text-white md:w-32 md:flex-shrink'>Get Started</button>
            </Link>
          </div>
          <div className='text-sm mt-4 italic'>
            * plus 5% of all click through revenue.
          </div>
        </div> */}
      </div>
    </div>
    // {/* <div className='md:text-2xl'> */}
    // {/* You can reach us at{' '} */}
    // {/* <a href='mailto:yourfriends@poplink.in'> */}
    // {/* <span className='text-gray-200 hover:text-white'>yourfriends@poplink.in</span> */}
    // {/* </a> */}
    // {/* . */}
    // </div>
  )
}

export default Pricing
